import PropTypes from "prop-types"
import React from "react"
import Autocomplete from "react-google-autocomplete"
import { withScriptjs } from "react-google-maps"
import { geocodeByPlaceId } from "react-google-places-autocomplete"
import "./placesAutocomplete.scss"

// Address lookup for the all-locations search. The field itself is
// uncontrolled, so the parent clears it by changing the `key` it renders this
// under, the same way it always has.

const PlacesAutocomplete = withScriptjs(props => {
  const placeChanged = params => {
    if (params.name === "") {
      props.placeChanged(null)
      return
    }

    // Pressing Enter without choosing a suggestion hands back only the typed
    // text, with no place to look up. Search for that text instead of failing.
    if (!params.place_id) {
      if (props.onUnmatchedText) props.onUnmatchedText(params.name)
      return
    }

    geocodeByPlaceId(params.place_id).then(
      response => {
        const geoCoor = {
          lat: response[0].geometry.location.lat(),
          lng: response[0].geometry.location.lng(),
        }
        const fullPlace = response[0].formatted_address
        props.placeChanged(geoCoor, fullPlace)
      },
      error => {
        console.error(error)
      }
    )
  }

  return (
    <div className="google-places-autocomplete-wrapper">
      <Autocomplete
        aria-label={props.ariaLabel || "Search for a Cortica center"}
        className="auto-complete"
        defaultValue={props.defaultValue}
        googleMapsScriptBaseUrl="https://maps.googleapis.com/maps/api/place/autocomplete/"
        onChange={event => props.onTextChange?.(event.target.value)}
        onPlaceSelected={placeChanged}
        options={{
          componentRestrictions: { country: "us" },
          types: ["geocode", "establishment"],
        }}
        placeholder={props.placeholder || "Enter your state/city or zip code "}
      />

      {props.onClear && props.hasValue && (
        <button
          aria-label="Clear search"
          className="clear-search-button"
          onClick={props.onClear}
          type="button"
        >
          <svg aria-hidden="true" fill="none" viewBox="0 0 24 24">
            <path
              d="M6 6l12 12M18 6L6 18"
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth="2"
            />
          </svg>
        </button>
      )}

      {/* A magnifying glass inside the empty field, swapped for the clear
          button once there is text. Decoration only, so clicks pass through
          to the field. */}
      {props.showSearchIcon && !props.hasValue && (
        <svg
          aria-hidden="true"
          className="field-search-icon"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
          <path
            d="M16.5 16.5 21 21"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="2"
          />
        </svg>
      )}
    </div>
  )
})

PlacesAutocomplete.propTypes = {
  ariaLabel: PropTypes.string,
  defaultValue: PropTypes.string,
  hasValue: PropTypes.bool,
  onClear: PropTypes.func,
  onTextChange: PropTypes.func,
  onUnmatchedText: PropTypes.func,
  placeChanged: PropTypes.func,
  placeholder: PropTypes.string,
  showSearchIcon: PropTypes.bool,
}

export default PlacesAutocomplete
